/** @deprecated Prefer `creator-domain.policy` — kept for existing imports. */
export {
  COMMUNITY_CUSTOM_DOMAIN_MAX,
  COMMUNITY_DOMAIN_VERIFICATION_PREFIX,
  CREATOR_CUSTOM_DOMAIN_MAX,
  CREATOR_DOMAIN_VERIFICATION_PREFIX,
  assertCommunityCustomHostname,
  assertCreatorCustomHostname,
  communityDomainTxtRecord,
  communityDomainVerificationHost,
  creatorDomainTxtRecord,
  creatorDomainVerificationHost,
  normalizeCommunityHostname,
  normalizeCreatorHostname,
} from './creator-domain.policy';
